import { Middleware } from 'redux'

import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'

import { NAMESPACE } from './instrumentAction'

export { NAMESPACE } from './instrumentAction'

// Create analytics middleware from a set of analytics handlers.

// Handlers are dictionaries keyed with analytics actionTypes.
// When a redux action decoratred with `.meta[@@analytics]` payload
// passes through this middleware, each handler with the .meta[@@analytics].type
// will be called with the `.meta` payload.
export function createAnalyticsMiddleware(
    handlers: Partial<AnalyticsHandlers>[],
): Middleware {
    return store => next => action => {
        const value = next(action) as {
            meta?: {
                [NAMESPACE]?: { type: keyof AnalyticsHandlers; payload: any }
            }
        }

        const meta = value.meta?.[NAMESPACE]

        if (meta) {
            const { type, payload } = meta
            // If there is a recognized analytics payload
            // then we pass that payload on to all registered
            // handlers that support the payload's event type.
            const state = store.getState()

            handlers.forEach(handler => {
                handler[type]?.(payload, state)
            })
        }

        return value
    }
}
